import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { MiningLandsPage } from './MiningLandsPage';
import { MiningLogPage } from './MiningLogPage';

/**
 * Arche wrapper for DFE Mining — provides ArcheLayout with sidebar
 * and handles sub-routing for mining pages.
 */
export function MiningArchePage() {
  return (
    <ArcheLayout>
      <Routes>
        <Route path="/" element={<MiningLandsPage />} />
        <Route path="/log" element={<MiningLogPage />} />
      </Routes>
    </ArcheLayout>
  );
}
